import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-archivesN",
  "use": "icon-archivesN-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-archivesN\"><defs><style type=\"text/css\"></style></defs><path d=\"M291.348154 1024H0V0h807.73404v252.762798h-35.922496V35.870283H35.870283v952.259434H291.348154v35.870283z\" p-id=\"28402\" /><path d=\"M700.227616 731.29431a207.703039 207.703039 0 1 1 207.703039-207.703039 207.911891 207.911891 0 0 1-207.703039 207.703039z m0-379.535795a171.832755 171.832755 0 1 0 172.041607 171.72833 171.989394 171.989394 0 0 0-172.041607-171.832756z\" p-id=\"28403\" /><path d=\"M1024 1019.091984h-35.870283a287.902101 287.902101 0 1 0-575.804202 0h-36.079135a323.720171 323.720171 0 0 1 647.440342 0z\" p-id=\"28404\" /><path d=\"M120.455231 205.457883h354.525801v35.870283h-354.525801z\" p-id=\"28405\" /><path d=\"M138.41648 351.654089h225.037732v35.870284h-225.037732z\" p-id=\"28406\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/archivesN.svg
// module id = Dzyr
// module chunks = 81